"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var NotificationIcon = function NotificationIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.1665 7.50009H5.83313V9.16676H14.1665V7.50009Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.6665 10.8334H5.83313V12.5001H11.6665V10.8334Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 1.66675H13.3332C16.0907 1.66675 18.3332 3.90925 18.3332 6.66675V13.3334C18.3332 16.0909 16.0907 18.3334 13.3332 18.3334H2.49984C2.039 18.3334 1.6665 17.9609 1.6665 17.5001V6.66675C1.6665 3.90925 3.909 1.66675 6.6665 1.66675ZM13.3332 16.6667C15.1715 16.6667 16.6665 15.1717 16.6665 13.3334V6.66675C16.6665 4.82841 15.1715 3.33341 13.3332 3.33341H6.6665C4.82817 3.33341 3.33317 4.82841 3.33317 6.66675V16.6667H13.3332Z",
    fill: color
  }));
};
var _default = NotificationIcon;
exports.default = _default;